import { RESET_POINT_OF_SALE_STATE } from '@dynameat/views/pointOfSale/mutationTypes';
import * as MutationTypes from './mutationTypes';

const groupIndexingRuleSuccess = (state, groupIndexingRuleList) => {
  state.groupIndexingRuleList = groupIndexingRuleList;
};

const createGroupIndexingRuleSuccess = (state, rule) => {
  state.groupIndexingRuleList.push(rule);
};

const updateGroupIndexingRuleSuccess = (state, groupIndexingRule) => {
  const index = state.groupIndexingRuleList.findIndex((rule) => (rule.guid === groupIndexingRule.guid));
  state.groupIndexingRuleList.splice(index, 1, groupIndexingRule);
};

const removeGroupIndexingRuleSuccess = (state, ruleGuid) => {
  state.groupIndexingRuleList = state.groupIndexingRuleList.filter((rule) => rule.guid !== ruleGuid);
};

const resetData = (state) => {
  state.groupIndexingRuleList = [];
};

export const mutations = {
  [MutationTypes.GROUP_INDEXING_RULE_LIST_SUCCESS]: groupIndexingRuleSuccess,
  [MutationTypes.CREATE_GROUP_INDEXING_RULE_SUCCESS]: createGroupIndexingRuleSuccess,
  [MutationTypes.UPDATE_GROUP_INDEXING_RULE_SUCCESS]: updateGroupIndexingRuleSuccess,
  [MutationTypes.REMOVE_GROUP_INDEXING_RULE_SUCCESS]: removeGroupIndexingRuleSuccess,
  [RESET_POINT_OF_SALE_STATE]: resetData,
};
